import { Stack, YStack, SizableText } from '@mythical/ui'
import { isIOS } from 'app/utils/constants'
import React from 'react'

import { UpgradeButton } from '../content/UpgradeButton'
import { IconLock } from '../primitive/Icon'
import LockModal from '../primitive/LockModal'

type CommentLockModalProps = {
  onUnlock: () => void
  planLevel: number | 'free'
  image: string
  id: string
}

const CommentLockModal = ({
  id,
  onUnlock,
  planLevel,
}: CommentLockModalProps) => {
  return (
    <Stack w="100%" position="relative" borderRadius="$2">
      <Stack
        borderRadius="$2"
        pos="absolute"
        w="100%"
        h="100%"
        zIndex="$1"
        bg="$secondary10"
        opacity={0.3}
      />
      <Stack w="100%" zIndex="$2">
        <LockModal flexGrow={1} id={id} onUnlock={onUnlock} loading={false}>
          <YStack space="$4" jc="center" ai="center">
            <Stack p="$3" bg="$secondary8" borderRadius="$2">
              <IconLock size={24} color="$primary6" />
            </Stack>
            <SizableText
              fontFamily="$heading"
              textTransform="uppercase"
              size="$7"
              color="$primary1"
              textAlign="center"
              fontWeight="500"
            >
              {isIOS
                ? 'You do not have the correct level of permissions to comment'
                : 'Upgrade to see comments and join the conversation'}
            </SizableText>
            {!isIOS && <UpgradeButton planLevel={planLevel} />}
          </YStack>
        </LockModal>
      </Stack>
    </Stack>
  )
}

export default CommentLockModal
